import { useState, useEffect } from 'react';
import './AboutUsIcon.css';
import AboutUsGuy from './Icons/AboutUsGuy';
import FlyingText from './Icons/AboutUsText';
import FlyingBook from './Icons/AboutUsBook';
const textStyling: React.CSSProperties = {
    position: "absolute",
    width: 60,
    zIndex: 2,
    fontSize: 12,
    textDecoration: "underline",
    color: "blue",
    fontWeight: 500,
};

const emojiStyling: React.CSSProperties = {
    position: "absolute",
    zIndex: 0,
    fontSize: 24,
};

const SWING_MS = 1500;
const FLYING_MS = 1500;
const STATE_IDLE = 0;
const STATE_FLYING = 1;
const STATE_DEAD = 2;

interface Props {
    callback: () => void;
    still: boolean;
}

export default function AboutUsIcon_NEW({ callback, still }: Props) {
    const [frame, setFrame] = useState<0 | 1 | 2 | 3>(0);
    const [animationState, setAnimationState] = useState(STATE_IDLE);

    useEffect(() => {
        if (animationState !== STATE_IDLE) {
            setFrame(2)
        }
        const timer = setInterval(() => {
            const f0: 0 | 2 = animationState === STATE_IDLE ? 0 : 2;
            const f1: 1 | 3 = animationState === STATE_IDLE ? 1 : 3;

            setFrame((prev) => (prev === f0 ? f1 : f0));
        }, SWING_MS / 2);

        return () => clearInterval(timer);
    }, [animationState]);

    if (animationState === STATE_DEAD) return <></>
    return (
        <div
            onClick={() => {
                if (animationState !== STATE_IDLE) return;
                setAnimationState(STATE_FLYING);
                const timer = setTimeout(() => {
                    setAnimationState(STATE_DEAD);
                    callback();
                }, FLYING_MS - 100)
                return () => clearTimeout(timer);
            }}
            // className={animationState === STATE_IDLE ? "about-us-swing" : ""}
            style={{
                position: "relative",
                width: 75,
                // background:'#746a6a',
                // overflow:'hidden',
                height: 75,
                top: animationState === STATE_IDLE ? 0 : 40,
                left: animationState === STATE_IDLE ? 0 : 15,
                ["--swing-ms" as any]: `${SWING_MS}ms`,
            }}
        >
            <span
                className={animationState === STATE_FLYING ? "about-us-bounce-and-fall" : ""}
                style={
                    {
                        ...textStyling,
                        ["--fall-ms" as any]: `${FLYING_MS -400}ms`,
                        ["--bounce-height-px" as any]: `${-90}px`,
                        visibility: animationState === STATE_IDLE ? 'hidden' : 'visible',
                        // top: 3,
                        // left: 5
                    }
                }
            >
                <FlyingText />
            </span>
            <span
                className={animationState === STATE_FLYING ? "about-us-bounce-and-fall" : ""}
                style={{
                    ...emojiStyling,
                    ["--fall-ms" as any]: `${FLYING_MS -100 }ms`,
                    ["--bounce-height-px" as any]: `${-110}px`,
                    visibility: animationState === STATE_IDLE ? 'hidden' : 'visible',

                    // top: 15,
                    // left: 14,
                }}

            >
                <FlyingBook />
            </span>

            <div
                className={animationState === STATE_FLYING ? "about-us-fly-away" : ""}
                style={{
                    ["--flying-ms" as any]: `${FLYING_MS - 500}ms`,
                    position: "absolute",
                    // backgroundColor:'blue',
                    zIndex: 2,

                    // top: 35,
                    // left: 22,
                }}
            >

                <div className={animationState === STATE_FLYING ? "about-us-spin" : ""}
                    style={{
                        // backgroundColor:'red',
                    }}
                >
                    <AboutUsGuy frame={still ? 0 : frame} animationClass0={STATE_FLYING ? "about-us-spin" : ""} animationClass1={''} />
                </div>

            </div>
        </div>
    );
}